import { BudgetContractor } from 'store/budget/interfaces';
import { Cost } from 'store/costs/costs';

export default function getInitValues({
  cost,
  assignedBudgetContractor,
}: {
  cost: Cost;
  assignedBudgetContractor: BudgetContractor | undefined;
}) {
  return {
    name: cost.name,
    costGroup: cost.costGroup['@id'],
    status: cost.status,
    tin: cost?.tin ?? '',
    matchRegex: cost.matchRegex ?? '',
    description: cost.description ?? '',
    ownerEmployee: cost.ownerEmployee ?? '',
    budget: assignedBudgetContractor?.budget ?? '',
    notIncludeInChart: cost.notIncludeInChart ?? false,
    fixedAmount: cost.fixedAmount ?? false,
    requireAttachment: cost.requireAttachment ?? false,
    cyclic: cost.cyclic ?? false,
    taxAmount: cost.taxAmount ?? '',
    paymentDeadline: cost.paymentDeadline
      ? cost.paymentDeadline.toString()
      : '',
  };
}
